import { useLayoutEffect, useRef } from 'react'
import { TIMELINE_START_HOUR, TIMELINE_END_HOUR } from '.'

const TECH_NAME_WIDTH = 224 // w-56
const VISIBLE_HOURS = 10
const TOTAL_HOURS = TIMELINE_END_HOUR - TIMELINE_START_HOUR
const SCROLL_TO_HOUR = 8

export const TIMELINE_WIDTH_PERCENT = (TOTAL_HOURS / VISIBLE_HOURS) * 100
export const TIMELINE_TECH_NAME_WIDTH = TECH_NAME_WIDTH

export function useScrollToHour() {
  const scrollRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const el = scrollRef.current
    if (!el) return
    const trackVisible = el.clientWidth - TECH_NAME_WIDTH
    const colWidth = trackVisible / VISIBLE_HOURS
    el.scrollLeft = (SCROLL_TO_HOUR - TIMELINE_START_HOUR) * colWidth
  }, [])

  return { scrollRef }
}
